import React, { useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import QRCode from 'qrcode';

function WindowSticker() {
    const location = useLocation();
    const { formValue, dataOne } = location.state || {};

    const qrCodeRef = useRef(null);

    const makeQRCode = () => {
        const elText = `https://holmesmotors.com/vehicle-details/${formValue.stock}?utm_source=window_sticker&utm_medium=qr_code&utm_campaign=organic&utm_content=HM`;

        QRCode.toCanvas(qrCodeRef.current, elText, { width: 100, height: 100 }, (error) => {
            if (error) console.error(error);
            console.log('QR code generated successfully!', elText);
        });
    };

    useEffect(() => {
        if (qrCodeRef.current) {
            makeQRCode();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!formValue || !dataOne) {
        return <div>Error: Failed to load vehicle data.</div>;
    }
    
    

    const maxGroupsToShow = 5; // Limit the number of groups
    const maxCategoriesToShow = 5; // Limit the number of categories within each group
    const maxEquipmentToShow = 3; // Limit the number of equipment items within each category

    const filteredEquipmentGroups = dataOne.us_market_data?.common_us_data?.standard_generic_equipment
        ?.filter(group => group.generic_equipment_category_group !== "Exterior" && group.generic_equipment_category_group !== "Performance")
        ?.slice(0, maxGroupsToShow) || [];

    return (
        <div className="container" style={{ paddingTop: '145px' }}>
            <style>
                {`
                    body, .container {
                        margin: 0;
                        padding: 0;
                        font-family: Arial, sans-serif;
                    }
                    .header, .details, .qr-code {
                        display: flex;
                        justify-content: space-between;
                        margin-top: 100px;
                        margin-bottom: -45px;
                    }
                    .details > div {
                        flex: 1;
                    }
                    .details p {
                        margin: 0;
                        padding: 0;
                        font-size: 14px;
                    }
                    .header h4, .header p {
                        margin: 0;
                        padding: 0;
                        font-size: 16px;
                        font-weight: 600;
                    }
                    .header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }
                    .header h4 {
                        flex: 1;
                        margin-top: 20px; /* Move the h4 down */
                    }
                    .qr-code {
                        margin-top: -40px; /* Move the QR code up */
                    }
                    .qr-code canvas {
                        margin-left: auto;
                    }
                    .equipment-container {
                        display: grid;
                        grid-template-columns: repeat(3, 1fr);
                        gap: 5px;
                        margin-right: 5px;
                        margin-top: -60px;
                    }
                    @media print {
                        .header, .details, .qr-code {
                            display: flex;
                            justify-content: space-between;
                            margin-top: 90px;
                            margin-bottom: -45px;
                        }
                        .equipment-container {
                            display: grid;
                            grid-template-columns: repeat(3, 1fr);
                            gap: 5px;
                            margin-right: 5px;
                            margin-top: -60px;
                        }
                        .details > div {
                            flex: 1;
                        }
                        .details p {
                            margin: 0;
                            padding: 0;
                            font-size: 14px;
                        }
                        .header h4, .header p {
                            margin: 0;
                            padding: 0;
                            font-size: 16px;
                            font-weight: 600;
                        }
                        .header h4 {
                            margin-top: 20px; /* Move the h4 down for print */
                        }
                        .qr-code {
                            margin-top: -40px; /* Move the QR code up for print */
                        }
                        .qr-code canvas {
                            margin-left: auto;
                        }
                    }
                `}
            </style>
            <div className="header">
                <h4>{formValue.year} {formValue.make} {formValue.model} {formValue.bodytype} {formValue.color}</h4>
                <p style={{ marginRight: 'auto' }}>
                    Stock #: {formValue.stock} <br />
                    VIN: {formValue.vin} <br />
                    Miles: {formValue.mileage} <br />
                </p>
                <div className="qr-code">
                    <canvas ref={qrCodeRef} style={{ width: '100px', height: '100px' }}></canvas>
                </div>
            </div>
            <div className="details">
                <div>
                    <p>
                        {dataOne?.us_market_data?.transmissions?.[0]?.name} <br />
                        {dataOne?.us_market_data?.engines?.[0]?.name}
                    </p>
                </div>
            </div>
            <div className="details">
                <div>
                    <p>
                        <strong>Location:</strong> {formValue.location} <br />
                        <strong>Year:</strong> {formValue.year} <br />
                        <strong>Make:</strong> {formValue.make} <br />
                        <strong>Model:</strong> {formValue.model} <br />
                        <strong>Mileage:</strong> {formValue.mileage} <br />
                        <strong>Body Style:</strong> {formValue.bodytype} <br />
                        <strong>Paint Color:</strong> {formValue.color} <br />
                        <strong>Engine:</strong> {dataOne.us_market_data?.us_styles?.[0]?.engines?.[0].name} <br />
                        <strong>Transmission:</strong> {dataOne.us_market_data?.us_styles?.[0]?.transmissions?.[0].name} <br />
                        <strong>VIN:</strong> {formValue.vin} <br />
                        <strong>Stock #:</strong> {formValue.stock} <br />
                    </p>
                    <h4 style={{ marginBottom: '2px' }}>EPA Fuel Efficiency:</h4>
                    <p style={{ fontSize: '14px' }}>
                        <strong>City:</strong> {dataOne.us_market_data?.us_styles?.[0]?.epa_fuel_efficiency?.[0]?.city} <br />
                        <strong>Highway:</strong> {dataOne.us_market_data?.us_styles?.[0]?.epa_fuel_efficiency?.[0]?.highway} <br />
                        <strong>Combined:</strong> {dataOne.us_market_data?.us_styles?.[0]?.epa_fuel_efficiency?.[0]?.combined} <br />
                    </p>
                    <h3>Down Payment: <small>${formValue.requireddown}.00</small> </h3>
                    <h3>Bi-weekly Payment: <small>${formValue.retailprice}.00</small> </h3>
                </div>
                <div className="equipment-container">
                    {filteredEquipmentGroups.map((group, groupIndex) => (
                        <div key={groupIndex} className="equipment-group">
                            <h4>{group.generic_equipment_category_group}</h4>
                            {group.generic_equipment_categories.slice(0, maxCategoriesToShow).map((category, catIndex) => (
                                <div key={catIndex}>
                                    <p style={{ fontSize: '12px' }}>
                                        {category.generic_equipment.slice(0, maxEquipmentToShow).map((equipment, equipIndex) => (
                                            <span key={equipIndex}>
                                                <strong>{equipment.generic_equipment_name}</strong>
                                                {equipment.generic_equipment_values
                                                    .filter(value => value.generic_equipment_value !== "")
                                                    .map((value, valueIndex) => (
                                                        <span key={valueIndex}>
                                                            {valueIndex > 0 && ", "}: {value.generic_equipment_value}
                                                        </span>
                                                    ))}
                                                <br />
                                            </span>
                                        ))}
                                    </p>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default WindowSticker;
